/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LandingPageFaqResponse } from './LandingPageFaqResponse';

export type ApiResponseListLandingPageFaqResponse = {
    message?: string;
    code?: ApiResponseListLandingPageFaqResponse.code;
    target?: Record<string, any>;
    exceptionCategory?: ApiResponseListLandingPageFaqResponse.exceptionCategory;
    errorType?: ApiResponseListLandingPageFaqResponse.errorType;
    body?: Array<LandingPageFaqResponse>;
    trackingId?: string;
};

export namespace ApiResponseListLandingPageFaqResponse {

    export enum code {
        DUPLICATED_NAME = 'DUPLICATED_NAME',
        NOT_FOUND_ENTITY = 'NOT_FOUND_ENTITY',
        EMPTY_FIELD = 'EMPTY_FIELD',
        BAD_VALUE = 'BAD_VALUE',
        NOT_FOUND_DOMAIN = 'NOT_FOUND_DOMAIN',
        UNSUPPORTED_DELETION = 'UNSUPPORTED_DELETION',
        EMPTY_VARIABLE_NAME = 'EMPTY_VARIABLE_NAME',
        BAD_REQUEST = 'BAD_REQUEST',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
        EXPIRED_REQUEST = 'EXPIRED_REQUEST',
    }

    export enum exceptionCategory {
        AUTHENTICATION = 'AUTHENTICATION',
        TEMPLATE = 'TEMPLATE',
        PRODUCT = 'PRODUCT',
        APPLICATION = 'APPLICATION',
        STANDARD = 'STANDARD',
        EVALUATION = 'EVALUATION',
        EVALUATION_FILE = 'EVALUATION_FILE',
        ITEM = 'ITEM',
        ANSWER = 'ANSWER',
        ANSWER_STANDARD = 'ANSWER_STANDARD',
        ANSWER_EVALUATION = 'ANSWER_EVALUATION',
        SURVEY = 'SURVEY',
        VARIABLE = 'VARIABLE',
        USER = 'USER',
        ETC = 'ETC',
        ALL = 'ALL',
    }

    export enum errorType {
        GET = 'GET',
        COPY = 'COPY',
        CREATE = 'CREATE',
        MODIFY = 'MODIFY',
        EVALUATION = 'EVALUATION',
        DELETE = 'DELETE',
        VALIDATE = 'VALIDATE',
    }


}

